import * as React from "react";

const STORAGE_KEY = "contacts-table-columns";

interface ColumnVisibilityConfig {
  selectedColumns: string[];
}

export function useColumnVisibility(fields: Array<{ id: string; name: string }>) {
  const [selectedColumns, setSelectedColumns] = React.useState<string[]>(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        const config: ColumnVisibilityConfig = JSON.parse(saved);
        return config.selectedColumns || [];
      }
    } catch (error) {
      console.warn("Failed to load column visibility from localStorage:", error);
    }
    return [];
  });

  React.useEffect(() => {
    try {
      const config: ColumnVisibilityConfig = {
        selectedColumns,
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
    } catch (error) {
      console.warn("Failed to save column visibility to localStorage:", error);
    }
  }, [selectedColumns]);

  const toggleColumn = React.useCallback((columnName: string) => {
    setSelectedColumns(prev => {
      const isSelected = prev.includes(columnName);
      return isSelected ? prev.filter(name => name !== columnName) : [...prev, columnName];
    });
  }, []);

  const resetToDefault = React.useCallback(() => {
    setSelectedColumns([]);
  }, []);

  const selectAllFields = React.useCallback(() => {
    const fieldColumns = fields.map(field => field.name);
    setSelectedColumns([...fieldColumns]);
  }, [fields]);

  return {
    selectedColumns,
    toggleColumn,
    resetToDefault,
    selectAllFields,
  };
}
